import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { Typography, Paper, Tooltip, useForkRef } from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import ModalFrame from "../../biztran_controls/Modal_Frame";
import AddProduct from "../StockInwards/AddProduct";
import EditProduct from "../StockInwards/EditProduct";
import UseFetchData from "../../../hooks/UseFetchData";

const StockInwardDtls = (props) => {
    debugger;
    const classes = useStyles();
    const [isOpen, setOpen] = useState(false);
    const [isEditOpen, setEditOpen] = useState(false);
    const [DateOk, setDateOk] = useState(false);
    const [Count, setCount] = useState();
    const [IDID, SetIDID] = useState("");
    const [EditIDID, setEditIDID] = useState("");
    const [StockID, setStockID] = useState("");
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [responseGetDate, fetchGetDate] = UseFetchData();

    const handleOpenModal = (row) => {
        if (DateOk === false) {
            setEditOpen(true);
            SetIDID(props.InventoryDocumentID);
            setEditIDID(props.EditIDID);
            setStockID(row.id);
        }
    };

    const OpenModal = () => {
        setOpen(true);
        SetIDID(props.InventoryDocumentID);
        // }
        setStockID("");
    };

    const GetByIDData = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("InventoryDocumentID", props.InventoryDocumentID);
        fetchGetDate("StockInward/GetInDate", bodyFormData);
    };

    useEffect(() => {
        debugger;
        console.log(responseGetDate.Response);
        if ((responseGetDate.Response === true)) {
            setDateOk(true);
        }
        else if (responseGetDate.Response === false) {
            setDateOk(false);
        }
    }, [responseGetDate])

    useEffect(() => {
        debugger;
        GetByIDData();
    }, [])


    useEffect(() => {
        debugger;
        const gridCols = [
            {
                field: "id",
                headerName: ".",
                renderCell: (params) => (
                    <strong>
                        {" "}
                        <a
                            href="javascript:;"
                            onClick={() => {
                                handleOpenModal(params);
                            }}

                        >
                            <EditIcon fontSize="small" />
                        </a>{" "}
                    </strong>
                ),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 34,
            },
            {
                field: "SerialNumber",
                headerName: ".",
                type: 'number',
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 34,
            },
            {
                field: "ProductName",
                headerName: "Product Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                renderCell: (params) => (
                    <Tooltip title={params.row.ProductName} >
                        <span className="table-cell-trucate">{params.row.ProductName}</span>
                    </Tooltip>
                )
            },
            {
                field: "ProductGroup",
                headerName: "Product Group",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                renderCell: (params) => (
                    <Tooltip title={params.row.ProductGroup} >
                        <span className="table-cell-trucate">{params.row.ProductGroup}</span>
                    </Tooltip>
                )
            },
            {
                field: "ModelCode",
                headerName: "Model Code",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 163,
            },
            {
                field: "Description",
                headerName: "Description",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 250,
                renderCell: (params) => (
                    <Tooltip title={params.row.Description} >
                        <span className="table-cell-trucate">{params.row.Description}</span>
                    </Tooltip>
                )
            },
            {
                field: "InQty",
                headerName: "Qty",
                type: 'number',
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 120,
            },
            // {
            //     field: "OutQty",
            //     headerName: "OutQty",
            //     type: 'number',
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 130,
            // },
            {
                field: "Rate",
                headerName: "Rate",
                type: 'number',
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            // {
            //     field: "Amount",
            //     headerName: " Amount",
            //     type: 'number',
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 180,
            // },
            {
                field: "Remarks",
                headerName: "Remarks",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
        ];
        setCount(Response.length);
        setColumns(gridCols);
        debugger;
        if (props.IDDtlsData != null && props.IDDtlsData.length > 0) {
            setRows(props.IDDtlsData);
        }

    }, [props.IDDtlsData]);




    return <Paper style={{ paddingLeft: 10, paddingRight: 10 }}>
        {/* <h2 style={{ textDecoration: "underline", textDecorationColor: "#0096FF", textDecorationThickness: 5, }}>
      DETAILS
    </h2> */}
        <Typography className={classes.headerCmn} noWrap>
            Item Details
            {/* <div style={{ float: "left",  width: 10 ,marginTop:25, marginLeft:7}}> */}
            <div style={{ width: "100%" }}>
                <div style={{ float: "right" }}>
                    <BiztranControls.Button
                        text="Add New"
                        style={{ margin: "0.2rem", height: "1.6rem" }}
                        startIcon={<AddCircleOutlineIcon />}
                        onClick={() => {
                            OpenModal();
                        }}
                    />
                </div>
            </div>
        </Typography>
        <Grid spacing={1} container style={{ marginTop: 7, paddingRight: 10 }}>
            <BiztranControls.DataGrid
                rowHeight={25}
                rows={rows}
                columns={columns}
                checkboxSelection={false}
                hideFooterPagination={false}
                Height="340px"
                Width="100%"
            />
            <ModalFrame
                title="Add Product"
                maxWidth="lg"
                isOpen={isOpen}
                setOpen={setOpen}
            >
                <AddProduct
                    IDID={IDID}
                    StockID={StockID}
                    setOpen={setOpen}
                    getByIDData={props.PopulateData}
                />
            </ModalFrame>

            <ModalFrame
                title="Edit Product"
                maxWidth="md"
                isOpen={isEditOpen}
                setOpen={setEditOpen}
            >
                <EditProduct
                    IDID={IDID}
                    StockID={StockID}
                    setOpen={setEditOpen}
                    getByIDData={props.PopulateData}
                />
            </ModalFrame>
        </Grid>
    </Paper>
};

const useStyles = makeStyles((theme) => ({
    header: {
        width: "100%",
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "1.7rem",
        fontSize: "1.8rem",
        display: "flex",
        flexDirection: "row",
    },
    headertext:
    {
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "2.7rem",
        fontSize: "1.8rem",
        display: "flex",
        flexDirection: "row",
        //   borderRadius: "1rem",
    },
    headerCmn: {
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "2rem",
        fontSize: "1rem",
        display: "flex",
        flexDirection: "row",
        //margin: "0.3rem",
        fontWeight: "bold",
    },
}));

export default StockInwardDtls;
